import { createSlice } from '@reduxjs/toolkit'
import axios from 'axios'


export const ingresaTNESlice = createSlice({
    name: 'ingresaTNE',
    initialState: {
        ingresaTNE: { sesion: [] }
    },
    reducers: {
        setIngresaTNE: (state, action) => {
            state.ingresaTNE = action.payload
        }
    }
})


export const { setIngresaTNE } = ingresaTNESlice.actions

export default ingresaTNESlice.reducer


export const getIngresaTNE = (data) => async (dispatch) => {

    try {

        return await axios
            .post(
                `${process.env.REACT_APP_API_URL}/v1_ufe/ufe_procesoTNE`, data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': process.env.REACT_APP_TOKEN
                    }
                }
            )
            .then(response => {
                console.log('dispatch ufe_ingresarTNE', response.data)
                dispatch(setIngresaTNE(response.data))
                return response.data
            })

    } catch (error) {

        console.log('dispatch error', error)

    }

}
